import React from "react";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    minWidth: 245,
    marginTop: 30
  },
  media: {
    height: 140
  }
});

export default function ImageLoadingCard() {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardActionArea>
        <div className={classes.media} title="" />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2" />
          <Typography variant="body2" color="textSecondary" component="p" />
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary">
          Show
        </Button>
      </CardActions>
    </Card>
  );
}
